import { ChannelType, MessageType } from "@/protocols/channel"
import { beautifyBytes, convertMegabytesToBytes } from "@/utils/format"

const BYTES_PER_KILOBYTE = 1024

const IMAGE_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA = 5
const VIDEO_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA = 16
const AUDIO_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA = 16
const DOCUMENT_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA = 40
const STATIC_STICKER_SIZE_LIMIT_IN_KILOBYTES_FOR_WABA = 100

const IMAGE_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB = 100
const VIDEO_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB = 180
const AUDIO_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB = 16
const DOCUMENT_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB = 40
const STATIC_STICKER_SIZE_LIMIT_IN_KILOBYTES_FOR_WEB = 100

const convertKilobytesToBytes = (kilobytes: number): number => kilobytes * BYTES_PER_KILOBYTE

const wabaMessageTypeToSizeLimitInBytes: Partial<Record<MessageType, number>> = {
	picture: convertMegabytesToBytes(IMAGE_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA),
	video: convertMegabytesToBytes(VIDEO_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA),
	audio: convertMegabytesToBytes(AUDIO_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA),
	file: convertMegabytesToBytes(DOCUMENT_SIZE_LIMIT_IN_MEGABYTES_FOR_WABA),
	sticker: convertKilobytesToBytes(STATIC_STICKER_SIZE_LIMIT_IN_KILOBYTES_FOR_WABA)
}

const webMessageTypeToSizeLimitInBytes: Partial<Record<MessageType, number>> = {
	picture: convertMegabytesToBytes(IMAGE_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB),
	video: convertMegabytesToBytes(VIDEO_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB),
	audio: convertMegabytesToBytes(AUDIO_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB),
	file: convertMegabytesToBytes(DOCUMENT_SIZE_LIMIT_IN_MEGABYTES_FOR_WEB),
	sticker: convertKilobytesToBytes(STATIC_STICKER_SIZE_LIMIT_IN_KILOBYTES_FOR_WEB)
}

const channelTypeToMessageSizeLimitInBytes: Record<ChannelType, Partial<Record<MessageType, number>>> = {
	waba: wabaMessageTypeToSizeLimitInBytes,
	whatsapp: webMessageTypeToSizeLimitInBytes
}

export const getMediaSizeLimitInBytes = (type: MessageType, channelType?: ChannelType): number => {
	const messageTypeToSizeLimitInBytes = channelType
		? channelTypeToMessageSizeLimitInBytes[channelType]
		: wabaMessageTypeToSizeLimitInBytes

	const sizeLimitInBytes = messageTypeToSizeLimitInBytes[type]

	return sizeLimitInBytes ?? Number.MAX_SAFE_INTEGER
}

export const formatMediaSizeLimit = (type: MessageType, channelType?: ChannelType): string => {
	const sizeLimitInBytes = getMediaSizeLimitInBytes(type, channelType)

	return beautifyBytes(sizeLimitInBytes, 0)
}
